import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { TextbookActionsComponent } from './textbook-actions/textbook-actions.component';
import { InternalApiService } from '../internal/internal-api.service';
import {
  TextbookActionsConfig,
  TextbookActionsDefaultConfig,
  TxtbActionsConfig,
} from './textbook-actions.config';
import { TextbookActionsService } from './textbook-actions/textbook-actions.service';
import { TextbookActionsHandlerToken } from './providers/textbook-actions-handler';
import { TextbookActionsInternalModule } from '../internal/actions/textbook-actions-internal.module';
import { CommonModule } from '@angular/common';
import { TextbookActionIconsComponent } from './textbook-action-icons/textbook-action-icons.component';
import { TextbookDrawerModule } from '@textbook-drawer';
import { CommonUtilityModule } from '../internal/common-utility/common-utility.module';

@NgModule({
  declarations: [TextbookActionsComponent, TextbookActionIconsComponent],
  exports: [TextbookActionsComponent, TextbookActionIconsComponent],
  providers: [
    {
      provide: TxtbActionsConfig,
      useValue: TextbookActionsDefaultConfig,
    },
    {
      provide: TextbookActionsService,
      useClass: TextbookActionsService,
    },
    {
      provide: InternalApiService,
      useClass: InternalApiService,
    },
  ],
  imports: [CommonModule, TextbookActionsInternalModule, CommonUtilityModule, TextbookDrawerModule],
})
export class TextbookActionsModule {
  static forRoot(
    textbookViewerConfig?: TextbookActionsConfig,
    textbookActionsHandler?: Provider & { provide: typeof TextbookActionsHandlerToken }
  ): ModuleWithProviders<TextbookActionsModule> {
    return {
      ngModule: TextbookActionsModule,
      providers: [
        {
          provide: TxtbActionsConfig,
          useValue: {
            ...TextbookActionsDefaultConfig,
            ...(textbookViewerConfig ?? {}),
          },
        },
        textbookActionsHandler ? textbookActionsHandler : [],
      ],
    };
  }
}
